import styled from "styled-components";
import colorPalette from "@streeteasy/design-system/deprecated/colors";

import { largeScreen } from "src/shared/constants/screenSizes";

const ErrorContainer = styled.div`
  background-color: #fee8e7;
  height: 70px;
  width: 100%;
`;

const ErrorText = styled.div`
  color: ${colorPalette.errorRed};
  display: inline-block;
  font-size: 14px;
  line-height: 22px;
  margin: 0 auto;
  margin-left: 18%;
  padding-top: 10px;
  text-align: center;
  width: 239px;

  @media (min-width: ${largeScreen}px) {
    width: 80%;
    padding-top: 20px;
    margin-left: 8%;
  }
`;

const ErrorCloseX = styled.div`
  display: inline-block;
  margin-left: 35px;
  margin-top: 25px;
  position: absolute;

  @media (min-width: ${largeScreen}px) {
    margin-left: 15px;
  }
`;

ErrorContainer.displayName = "ErrorContainer";
ErrorText.displayName = "ErrorText";
ErrorCloseX.displayName = "ErrorCloseX";

export { ErrorContainer, ErrorText, ErrorCloseX };
